/**
 * `/studio/clients/$slug/blog/$widgetRef` — a client's blog, for the studio
 * (`.docs/46-blog-and-forms.md` decision 12: writing posts for a client is a studio
 * service). The page is `pages/blog/PostsPage.tsx`, the one the client's portal mounts;
 * `StudioBlog` is the studio's door into it, over the `blog_*` actions.
 *
 * **`$slug_`, not `$slug`**: the client page `/studio/clients/$slug` is a leaf, and a
 * route under it would render inside that page with no outlet. The trailing underscore
 * hangs this one beside it instead, at the same address shape, without moving the client
 * page's own route. A manager's, by `auth/guards.ts` `STUDIO_ROUTE_ROLE` saying nothing
 * about it.
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../../../../errors/NotFound.js'
import { PostsPage } from '../../../../../../pages/blog/PostsPage.js'
import { parsePostsSearch } from '../../../../../../pages/blog/search.js'
import { StudioBlog } from '../../../../../../pages/studio/blog/StudioBlog.js'

export const Route = createFileRoute('/studio/clients/$slug_/blog/$widgetRef/')({
  beforeLoad: ({ params }) => {
    if (!isRef('client', params.slug) || !isRef('widget', params.widgetRef)) throw notFound()
  },
  validateSearch: parsePostsSearch,
  /** R3-13: the boundary is this route, so the studio shell outlives the refusal. */
  notFoundComponent: NotFound,
  component: StudioPostsRoute,
})

function StudioPostsRoute() {
  const { slug, widgetRef } = Route.useParams()
  return (
    <StudioBlog slug={slug} widgetRef={widgetRef}>
      <PostsPage />
    </StudioBlog>
  )
}
